var _a;
import { ECourseColumns } from "./store/store";
export var MAIN_CONTAINER = "ws-container";
export var MAIN_WRAP = "websail";
export var LEFT_COLUMN = "ws-left-column";
export var RIGHT_COLUMN = "ws-right-column";
export var BLOCK = "ws-block";
export var BILLER_META = "ws-biller-meta";
export var STEP_META = "ws-step-meta";
export var REGISTER_DIFFERENT_PARTICIPANTS = "ws-register-different-participants";
export var BOOKING_FORM = "ws-booking-form";
export var CURSOR_POINTER = "ws-cursor-pointer";
export var SVG = "ws-svg";
export var INLINE_FIELDS = "ws-inline-fields";
export var FLASH_NOTIFICATIONS = "ws-flashnotifications";
export var CALENDER = "ws-calender";
export var DATE_TILE = "ws-date-tile";
export var DATE_PICKER_PORTAL = "ws-date-picker-portal";
export var NOTIFICATION_WRAP = "ws-notification-wrap";
export var NOTIFICATION = "ws-notification";
export var NOTIFICATION_HEADER = "ws-notification-header";
export var NOTIFICATION_CLOSE = "ws-notification-close";
export var NOTIFICATION_TYPE = {
    danger: "ws-notification-danger",
    success: "ws-notification-success",
    info: "ws-notification-info",
    warning: "ws-notification-warning"
};
export var BUTTON = "ws-button";
export var BUTTON_ICON = "ws-button-icon";
export var BUTTON_ICON_LEFT = "ws-button-icon-left";
export var BUTTON_ICON_RIGHT = "ws-button-icon-right";
export var BUTTON_TEXT = "ws-button-text";
export var FORM_BUTTONS = "ws-form-buttons";
export var BUTTON_FORM_SUBMIT = "ws-button-submit";
export var BUTTON_FORM_BACK = "ws-button-back";
export var FLEX = "ws-flex";
export var FLEX_NOWRAP = "ws-flex-nowrap";
export var FLEX_ROW = "ws-flex-row";
export var FLEX_COLUMN = "ws-flex-column";
export var COURSE_META = "ws-course-meta";
export var COURSE_TITLE = "ws-course-title";
export var COURSE_DESCRIPTION = "ws-course-description";
export var TIMESPAN_TITLE = "ws-timespan-title";
export var TIMESPAN_DESCRIPTION = "ws-timespan-description";
export var TIMESPAN_TITLE_PRICE = "ws-timespan-title-price";
export var LAST_COURSE = "ws-course-last";
export var FORM_DESCRIPTION = "ws-form-description";
export var PRICE_DESCRIPTION = "ws-price-description";
export var PRICE_BREAKUP = "ws-price-breakup";
export var PRICE_ROW = "ws-price-row";
export var PRICE_TOTAL = "ws-price-total";
export var PRICE_LINE_TOTAL = "ws-price-line-total";
export var COUNT_OF_PARTICIPANTS = "ws-count-of-participants";
export var SUB_PRICE = "ws-sub-price";
export var EXTRA_PRICE = "ws-extra-price";
export var PARTICIPANT_GROUP = "ws-participant-group";
export var PARTICIPANT_GROUP_FLAT = "ws-participant-group-flat";
export var ACCORDION = "ws-accordion";
export var ACCORDION_PANE = "ws-accordion-pane";
export var ACCORDION_HEADER = "ws-accordion-header";
export var ACCORDION_ARROW = "ws-accordion-arrow";
export var ACCORDION_TITLE = "ws-accordion-title";
export var ACCORDION_ICONS = "ws-accordion-icons";
export var ACCORDION_BODY = "ws-accordion-body";
export var ACCORDION_OPEN = "ws-accordion-open";
export var ACCORDION_CLOSED = "ws-accordion-close";
export var ACCORDION_STATE = "ws-state";
export var ACCORDION_VALID = "ws-accordion-valid";
export var ACCORDION_INVALID = "ws-accordion-invalid";
export var WIZARD = "ws-wizard";
export var WIZARD_STEP = "ws-step";
export var WIZARD_NAV = "ws-step-nav";
export var WIZARD_NAV_SELECTED = "ws-step-nav-selected";
export var WIZARD_NAV_TITLE = "ws-step-nav-title";
export var WIZARD_NAV_GROUP_LABEL = "ws-step-nav-group-title";
export var WIZARD_STEP_DESCRIPTION = "ws-wizard-description";
export var WIZARD_NAV_GROUP = "ws-step-nav-group";
export var WIZARD_NAV_GROUPPED = "ws-step-nav-groupped";
export var SWITCH = "ws-yes-no";
export var SWITCHABLE_FIELD = "ws-switchable-field";
export var RADIO_GROUP = "ws-radio-group";
export var INLINE_FLEX = "ws-inline-flex";
export var INPUT_LABEL = "ws-input-label";
export var INPUT_GROUP = "ws-input-group";
export var INPUT_GROUP_POST_FIX = "-container";
export var TEXT_INPUT = "ws-text-input";
export var INPUT = "ws-input";
export var INPUT_DESCRIPTION = "ws-input-description";
export var INPUT_RECOMMENDED = "ws-input-recommended";
export var INPUT_RECOMMENDED_TITLE = "ws-recommended-title";
export var INPUT_RECOMMENDED_INNER = "ws-recommended-wrap";
export var SELECT = "ws-select";
export var SEARCH_SELECT_OPTION = "ws-search-select-option";
export var SEARCH_SELECT_OPTION_DISABLED = "ws-search-select-option-disabled";
export var SEARCH_SELECT_SEARCH_INPUT = "ws-search-select-input";
export var SEARCH_SELECT_SEARCH_QUERY_CONTAINER = "ws-search-select-query";
export var SEARCH_SELECT_SEARCH_QUERY_INPUT = "ws-search-select-query-input";
export var SEARCH_SELECT_SEARCH_OPTIONS = "ws-search-select-options";
export var SEARCH_SELECT_GROUP_HEADER = "ws-search-select-group-header";
export var HIDDEN = "ws-hidden";
export var IS_INVALID = "ws-is-invalid";
export var IS_VALID = "ws-is-valid";
export var VALIDATION_MESSAGE_HEADER = "ws-validation-message-header";
export var VALIDATION_MESSAGE_LIST = "ws-validation-message-list";
export var VALIDATION_MESSAGE = "ws-validation-message";
export var COURSE_FILTERS = "ws-course-filters";
export var TABS = "ws-tabs";
export var TAB_BAR = "ws-tab-bar";
export var TAB_CONTENT = "ws-tab-content";
export var TAB = "ws-tab";
export var TAB_ACTIVE = "ws-tab-active";
export var TABLE = "ws-table";
export var TABLE_HEAD_ROW = "ws-head-row";
export var TABLE_BODY_ROW = "ws-data-row";
export var TABLE_BODY_ROW_BOOKED_OUT = "ws-data-row-booked-out";
export var TABLE_BODY_ROW_FEW_PLACES_LEFT = "ws-data-row-few-places-left";
export var TABLE_BODY_ROW_WAITLIST = "ws-data-row-waitlist";
export var TABLE_BODY_ROW_EXPANDED = "ws-data-row-expanded";
export var TABLE_BODY_DESCRIPTION_ROW = "ws-data-description-row";
export var TABLE_HEAD_CELL = "ws-header-cell";
export var TABLE_BODY_CELL = "ws-cell";
export var TABLE_BODY_CELL_SPAN = "ws-cell-span";
export var TABLE_BODY_CELL_LINK = "ws-cell-link";
export var TABLE_BODY_BOOK_LINK_WAITING_LINK = "ws-waiting-list-link";
export var TABLE_BODY_BOOK_NOW_LINK = "ws-book-now-link";
export var TEXT_ALIGN_LEFT = "ws-text-align-left";
export var TEXT_ALIGN_RIGHT = "ws-text-align-right";
export var TEXT_ALIGN_CENTER = "ws-text-align-center";
export var ENTITY_TABLE = "ws-entity-table";
export var ENTITY_HEAD_CELL_PREFIX = "ws-entity-header-cell";
export var SIGN_IN_FORM = "ws-signin-form";
export var SIGN_IN = "ws-button-signin";
export var SIGN_IN_BUTTON = "ws-button-signin-button";
export var SIGN_IN_BUTTON_ERRORED = "ws-button-signin-button-errored";
export var USER_SIGN_IN = "ws-button-user-sign-in";
export var USER_AUTHENTICATED = "ws-button-user-authenticated";
export var USER_AUTHENTICATED_MENU = "ws-user-menu";
export var USER_NEEDS_TO_PAY = "ws-user-due-amount";
export var USER_NEXT_APPOINTMENT = "ws-next-appointment";
export var CHIP = "ws-chip";
export var CHIP_LABEL = "ws-chip-label";
export var AVATAR = "ws-avatar";
export var AVATAR_IMAGE = "ws-avatar-image";
export var AVATAR_LABEL = "ws-avatar-label";
export var APPOINTMENT_LIST = "ws-appointment-list";
export var SHOW_MORE_TOGGLE = "ws-appointment-list-toggle";
export var SHOW_MORE = "ws-appointment-list-show-more";
export var SHOW_LESS = "ws-appointment-list-show-less";
export var TABLE_CELLS = (_a = {},
    _a[ECourseColumns.COURSE] = "ws-course-cell",
    _a[ECourseColumns.PLACE] = 'ws-place-cell',
    _a[ECourseColumns.FROM] = 'ws-from-cell',
    _a[ECourseColumns.TO] = 'ws-to-cell',
    _a[ECourseColumns.PRICE] = 'ws-price-cell',
    _a[ECourseColumns.TRAINER] = 'ws-trainer-cell',
    _a[ECourseColumns.INFO] = 'ws-info-cell',
    _a[ECourseColumns.APPOINTMENTS] = 'ws-appointments-cell',
    _a[ECourseColumns.REMAINING] = 'ws-remaining-cell',
    _a[ECourseColumns.DESCRIPTION] = 'ws-description-cell',
    _a[ECourseColumns.BOOKLINK] = 'ws-booklink-cell',
    _a);
export var COURSE_TABLE = "ws-table-courses";
export var COURSE_ACCORDION = "ws-course-accordion";
export var COURSE_INFO = "ws-course-info";
export var PAGINATION = "ws-pagination";
export var PRICE_TOGGLE = "ws-price-toggle";
export var PRICE_COLLAPSE = "ws-price-collapse";
export var PRICE_EXPAND = "ws-price-expand";
export var PRICE_CHECKBOX_TITLE = "ws-price-title";
export var PRICE_TITLE = "ws-price-title-cell";
export var PRICE_QUANTITY = "ws-price-quantity-cell";
export var PRICE_AMOUNT = "ws-price-amount-cell";
export var PAYMENT_GATEWAY = "ws-payment-gateway";
export var PAYMENT_GATEWAY_RECOMMENDED = "ws-payment-gateway-recommended";
export var PAYMENT_GATEWAY_RECOMMENDED_LABEL = "ws-payment-gateway-recommended-label";
export var PAYMENT_GATEWAY_IMAGE = "ws-payment-gateway-image";
export var PAYMENT_GATEWAY_INFO = "ws-payment-gateway-info";
export var PAYMENT_GATEWAY_RADIO = "ws-payment-gateway-radio";
export var PAYMENT_GATEWAY_RADIO_SELECTED = "ws-payment-gateway-radio-selected";
export var PAYMENT_GATEWAY_RADIO_INVALID = "ws-payment-gateway-radio-invalid";
export var COUPON_CODE = "ws-coupon-code";
export var COUPON_CODE_BUTTON = "ws-coupon-code-button";
export var COUPON_CODE_BUTTON_APPLY = "ws-coupon-code-button-apply";
export var COUPON_CODE_BUTTON_CLEAR = "ws-coupon-code-button-clear";
export var BANK_TRANSFER_BANK = "ws-bank-transfer-bank";
export var BANK_TRANSFER_LABEL = "ws-bank-transfer-label";
export var BANK_TRANSFER_VALUE = "ws-bank-transfer-value";
export var BANK_TRANSFER_PURPOSE = "ws-payment-purpose";
export var BANK_TRANSFER_DETAILS = "ws-bank-transfer-details";
export var NO_DATA_TO_DISPLAY = "ws-nothing-to-display";
export var SPINNER = "ws-spinner";
export var SEPA_DIRECT_DEBIT = "ws-sepa-direct-debit";
export var SEPA_DIRECT_DEBIT_TITLE = "ws-sepa-direct-debit-title";
export var SEPA_DIRECT_DEBIT_DESCRIPTION = "ws-sepa-direct-debit-description";
export var FIELD_SET = "ws-fieldset";
export var FIELD_SET_TITLE = "ws-fieldset-title";
export var FIELD_SET_DESCRIPTION = "ws-fieldset-description";
export var CARD = "ws-card";
export var CARD_TITLE = "ws-card-title";
export var CARD_DESCRIPTION = "ws-card-description";
export var CONSENT_PAGE = "ws-consent-page";
export var CART = "ws-cart";
export var ADD_TO_CART_BUTTON = "ws-add-to-cart-button";
export var CART_PREVIEW = "ws-cart-preview";
export var CART_PREVIEW_FLOATING = "ws-cart-preview-floating";
export var CART_PREVIEW_INLINE = "ws-cart-preview-inline";
export var CART_ITEM_COUNT = "ws-cart-count";
export var CART_EMPTY = "ws-cart-empty";
export var CART_PREVIEW_TEXT = "ws-cart-preview-text";
export var CART_PREVIEW_ICON = "ws-cart-preview-icon";
export var CART_PREVIEW_QUANTITY = "ws-cart-preview-quantity";
export var CART_PREVIEW_TOTAL = "ws-cart-preview-total";
export var ADD_TO_CART_POPUP = "ws-add-to-cart-popup";
export var TO_CART_BUTTON = "ws-to-cart-button";
export var TO_BOOK_NOW_BUTTON = "ws-to-book-now-button";
export var TO_CONTINUE_BUTTON = "ws-to-continue-button";
export var CART_WRAPPER = "ws-cart-wrapper";
export var CART_VIEW = "ws-cart-view";
export var CART_TABLE = "ws-cart-table";
export var CART_TABLE_ROW = "ws-cart-row";
export var CART_TABLE_ROW_ADMIN = "ws-cart-row-admin";
export var CART_TABLE_ROW_UI = "ws-cart-row-ui";
export var CART_TABLE_ROW_DESCRIPTION = "ws-cart-row-description";
export var CART_TITLE = "ws-cart-title";
export var CART_QUANTITY = "ws-cart-quantity";
export var CART_PRICE = "ws-cart-price";
export var CART_TOTAL = "ws-cart-total";
export var CART_MODIFY = "ws-cart-modify";
export var CART_REMOVE = "ws-cart-remove";
export var CART_ITEM = "ws-cart-item";
export var CART_EXTRA_ITEM = "ws-cart-extra-item";
export var MODAL_OVERLAY = "ws-modal-overlay";
export var MODAL_CONTENT = "ws-modal-content";
export var MODAL_CONTENT_INNER = "ws-modal-content-inner";
export var MODAL_CLOSE = "ws-modal-close";
export var TOAST = "ws-toast";
export var TOAST_CONTAINER = "ws-toast-container";
export var TOAST_PROGRESS = "ws-toast-progress";
export var TOAST_CONTEXT = {
    success: "ws-toast-success",
    danger: "ws-toast-danger",
    info: "ws-toast-info",
    warning: "ws-toast-warning",
};
export var MESSAGES = "ws-messages";
export var MESSAGE = "ws-message";
export var MESSAGE_CATEGORY_PREFIX = "ws-message-category";
export var MESSAGE_HEADER = "ws-message-attachment-header";
export var MESSAGE_TITLE = "ws-message-attachment-title";
export var MESSAGE_ATTACHMENT = "ws-message-attachment";
export var MESSAGE_ATTACHMENT_ICON = "ws-message-attachment-icon";
export var MESSAGE_BODY = "ws-message-body";
export var MESSAGE_DRAFT_MESSAGE = "ws-message-drafted";
export var ADMIN_BOOKING_FORM_SETTINGS = "ws-admin-settings";
export var ADMIN_CUSTOMER_DISCOVERY = "ws-customer-search-select";
export var TIME_SLOTS = {
    ALL_SLOTS: "ws-timeslots",
    SLOT: "ws-timeslot",
    SLOT_SELECTED: "ws-timeslot-selected",
    SLOT_DISABLED: "ws-timeslot-disabled",
    FILTER: "ws-timeslot-filter",
    FILTER_SELECTED: "ws-timeslot-filter-selected",
    TIME_SLOT_HIDDEN: "ws-time-slots-hidden"
};
export var CONFIRM_CANCEL_BOOKING_WRAPPER = "ws-event-to-cancel";
